// Champs automatiques des certificats médicaux (04/10/2026) : insérés dans les modèles (Paramètres), remplacés
// partout dans le texte à l'ouverture de la fenêtre « Nouveau certificat médical ».

export const CHAMPS_CERTIFICAT = [
	{ code: '[NOM_PATIENT]', libelle: 'Nom du patient' },
	{ code: '[DATE_NAISSANCE_PATIENT]', libelle: 'Date de naissance' },
	{ code: '[AGE_CLINIQUE]', libelle: 'Âge' },
	{ code: '[DOSSIER_PATIENT]', libelle: 'N° de dossier' },
	{ code: '[NOM_MEDECIN]', libelle: 'Médecin' },
	{ code: '[DATE]', libelle: 'Date du jour' },
	{ code: '[VILLE]', libelle: 'Ville' },
	{ code: '[NOM_CLINIQUE]', libelle: 'Établissement' },
]

export function remplirChampsCertificat(texte, valeurs) {
	let contenu = String(texte || '')
	Object.keys(valeurs).forEach(code => {
		const valeur = valeurs[code]
		contenu = contenu.split(code).join(valeur === null || valeur === undefined ? '' : String(valeur))
	})
	return contenu
}

export function extraitCertificat(texte, longueur) {
	const brut = String(texte || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
	const max = longueur || 140
	return brut.length > max ? brut.slice(0, max - 1) + '…' : brut
}
